import { lookup, leavePolicyActions } from '../../../lib/apiList'
import axios from '../../../lib/axios'
import { GetLeavePoliciesRequest, CreateLeavePolicyRequest } from './types'

export const getLeavePolicies = (
    body: GetLeavePoliciesRequest
): Promise<any> => {
    const response = axios.post(lookup.LEAVEPOLICY, body)
    return response
}

export const addLeavePolicies = (
    body: CreateLeavePolicyRequest
): Promise<any> => {
    const response = axios.post(leavePolicyActions.CREATE_LEAVE_POLICY, body)
    return response
}

export const UpdateLeavePolicies = (
    body: CreateLeavePolicyRequest
): Promise<any> => {
    const response = axios.put(leavePolicyActions.UPDATE_LEAVE_POLICY, body)
    return response
}
